define('models/conceptStrategy',["jQuery", "Underscore", "T1", "T1Model"], function ($, _, T1, T1Model) {
  T1.Models.ConceptStrategy = T1Model.extend({
    url: "strategy_concepts/",
    fixture: "-conceptStrategy"
  });
  return T1.Models.ConceptStrategy;
});
